export default __webpack_public_path__ + "static/media/img_14.8ad50908.webp";